import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=b0caadce&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=b0caadce&prod&scoped=true&lang=css"
import style1 from "./Landing.vue?vue&type=style&index=1&id=b0caadce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0caadce",
  null
  
)

export default component.exports